import { Component } from '@angular/core';

@Component({
  selector: 'app-te-domain-data',
  templateUrl: './te-domain-data.component.html',
  styleUrls: ['./te-domain-data.component.css']
})
export class TeDomainDataComponent {

}
